import type { CourseLesson$result } from '$houdini';
import { AccessLevel } from '$houdini/graphql/enums';
import type { Session } from '@supabase/supabase-js';

export function canUserAccessCourseLesson(
	session: Session | null,
	course: CourseLesson$result['course'] | null | undefined,
	lessonSlug: string
): boolean {
	// TODO: check course access level

	const lesson = course?.lessons.find((l) => l.slug === lessonSlug);

	if (lesson?.accessLevel) {
		switch (lesson.accessLevel) {
			case AccessLevel.public:
				return true;
			case AccessLevel.member:
				return !!session?.user;
			case AccessLevel.paid:
				console.warn('No rule for paid access level yet!');
				return false;
		}
		return false;
	} else {
		throw Error('ERROR in canAccessLesson: No lesson provided or no accessLevel');
	}
}
